import { render, staticRenderFns } from "./OffersTabs.vue?vue&type=template&id=304d352e&scoped=true&"
import script from "./OffersTabs.vue?vue&type=script&lang=js&"
export * from "./OffersTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304d352e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('304d352e')) {
      api.createRecord('304d352e', component.options)
    } else {
      api.reload('304d352e', component.options)
    }
    module.hot.accept("./OffersTabs.vue?vue&type=template&id=304d352e&scoped=true&", function () {
      api.rerender('304d352e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/internet/showcase/components/OffersTabs.vue"
export default component.exports